/**
 * fadeOutNotification fades an element and then removes it from the DOM
 * @param m the element to remove
 */
const fadeOutNotification = async (m: Element) => {
  m.classList.remove("animate__fadeInDown");
  m.classList.add("animate__fadeOutUp");
  m.addEventListener("animationend", () => {
    m.remove();
  });
};

/**
 * removeNotifications sets a timeout to automatically remove flashed messages
 */
const removeNotifications = async () => {
  const messages = document.querySelectorAll("div.flash");
  if (messages.length !== 0) {
    setTimeout(
      () => {
        messages.forEach(m => fadeOutNotification(m));
      },
      5000,
      messages,
    );
  }
};

export default removeNotifications;
